
function InfiniteLodging() {
    return (
        <>
            <div id="description">
                <p className="text-3xl mb-3">Description</p>
                <p>
                    InfiniteLodging was the very first web app that I had ever created, which is why it holds a special place here. It kickstarted my web application journey. It was essentially just AirBnB. That's it. Inclusive of a fake Stripe demo. 
                </p>
                <br/>
            </div>
            <div id="project_reflect">
                <span className="bggradienthorizontal w-full h-[1px] my-5 block"></span>
                <p className="text-3xl mb-4">Reflections</p>
                <p>
                    The database was local, and everything else was hosted locally. However, it sparked my love for web development by how easy it was as well as the endless possibilities that lay before me.
                </p>
            </div>
        </>
    );
}

export default InfiniteLodging;
